<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="音频地址" prop="musicUrl" >
<!--        <file-upload type="file" :defaultList="form.musicUrlArr" :count="1"-->
<!--                     @input="getImg($event, 'musicUrl')"></file-upload>-->
        <audio :src="form.musicUrl" :autoplay="false"
               controls="controls"/>
      </a-form-model-item>
<!--      <a-form-model-item label="音频时长" prop="duration" >-->
<!--        <a-input v-model="form.duration" placeholder="请输入音频时长" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="播放次数" prop="playNum" >-->
<!--        <a-input v-model="form.playNum" placeholder="请输入播放次数" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="是否推荐" prop="isRecommend" >
        <a-select  v-model="form.isRecommend">
          <a-select-option :value="1">是</a-select-option>
          <a-select-option :value="0">否</a-select-option>
        </a-select>
      </a-form-model-item>
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMusic, addMusic, updateMusic } from '@/api/music/music'
import {guid} from "@/utils/ruoyi";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        musicUrl: null,
        musicUrlArr:[],
        musicUrlCount:0,
        duration: null,

        playNum: null,

        isRecommend: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        musicUrl: [
          { required: true, message: '音频地址不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },

    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },

    // 取消按钮
    cancel () {
      this.reset()
      this.open = false
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        musicUrl: null,
        duration: null,
        playNum: null,
        isRecommend: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.open = true
      this.reset()
      this.formType = 1
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMusic({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        let that = this;
        this.form.musicUrlArr = []
        this.form.musicUrlArr.push({
          uid: guid(8, 10),
          name: that.form.musicUrl,
          status: 'done',
          halfUrl: that.form.musicUrl,
          url: that.form.musicUrl,
          path: that.form.musicUrl
        })
    })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateMusic(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addMusic(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
